// src/pages/locations/hooks/useDefaultCountry.ts
import React from "react";

import type { LocationCountry } from "@/api/features/locations/types";

/** Most of this catalogue is Indian data, so it is the useful landing point. */
export const DEFAULT_COUNTRY = "IN";

/**
 * Seeds the country filter once, so Regions/Cities open on real data instead of
 * an empty "select a country" screen. Applied a single time per mount: after
 * that the selection belongs to the user, including clearing it.
 */
export function useDefaultCountry(params: {
  country: string;
  countries: LocationCountry[];
  setCountry: (iso2: string) => void;
}) {
  const { country, countries, setCountry } = params;
  const applied = React.useRef(false);

  React.useEffect(() => {
    if (applied.current) return;

    // The URL already carries a country — nothing to seed.
    if (country) {
      applied.current = true;
      return;
    }

    if (countries.length === 0) return; // still loading

    applied.current = true;

    if (countries.some((c) => c.iso2 === DEFAULT_COUNTRY)) {
      setCountry(DEFAULT_COUNTRY);
    }
  }, [country, countries, setCountry]);
}
